import _ from 'lodash';
import React from 'react';

import FailsafeImg from 'components/global/application/FailsafeImg';
import { imageUrlAppendStyle } from 'contexts/link_util';

import { InstrumentsApi } from 'providers/api';
import Lightbox from 'react-image-lightbox';

import Log from '../../../providers/log';

import './InstrumentGroupItem.sass';

import { InstrumentGroupItem as InstrumentGroupItemNode } from 'types/drupal/InstrumentGroupNode';
import { DetailInstrument } from '../../../types/drupal/InstrumentNode';

import { instrumentImageAltRef, instrumentImageUrlRef } from 'contexts/instrument';

import { renderPrice } from 'contexts/prices';

interface Props {
    className?: string;
    isMobile: boolean;
    instrumentGroupItem: InstrumentGroupItemNode;
    showPrice: boolean;
}

interface State {
    isLighboxOpen: boolean;
    item: DetailInstrument;
    itemLoaded: boolean;
    lightboxIndex: number;
    slideImageIndex: number;
}

class InstrumentGroupItem extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            isLighboxOpen: false,
            item: null,
            itemLoaded: true,
            lightboxIndex: 0,
            slideImageIndex: 0
        };
    }

    public imageClick() {
        const targetPath = this.props.instrumentGroupItem.instrument.alias;
        InstrumentsApi.getInstrument(targetPath).then((item: DetailInstrument) => {
            this.setState({ item, itemLoaded: true });
        }).catch(reason => Log.error(reason));
    }

    public renderLightbox = (images: any) => {
        if (!this.state.isLighboxOpen) {
            return;
        }
        const image = images[this.state.lightboxIndex];
        const nextIndex = (this.state.lightboxIndex + 1) % images.length;
        const nextImage = images[nextIndex];
        const prevIndex = (this.state.lightboxIndex + images.length - 1) % images.length;
        const prevImage = images[prevIndex];

        return (
            <Lightbox
                animationDisabled={true}
                imageTitle={image.title ? image.title : ''}
                mainSrc={image.file.url}
                nextSrc={nextImage.file.url}
                prevSrc={prevImage.file.url}
                onCloseRequest={() => this.setState({ isLighboxOpen: false })}
                onMovePrevRequest={() => this.setState({ lightboxIndex: prevIndex })}
                onMoveNextRequest={() => this.setState({ lightboxIndex: nextIndex })}
            />
        );
    }

    public render() {

        const manufacturer = _.get(this.props.instrumentGroupItem, 'instrument.field_manufacturer.manufacturer.name');
        const model = _.get(this.props.instrumentGroupItem, 'instrument.field_instr_model.value');
        const year = _.get(this.props.instrumentGroupItem, 'instrument.field_instr_year.value');
        const description = this.props.instrumentGroupItem.instrument.field_instr_product_description ? this.props.instrumentGroupItem.instrument.field_instr_product_description.value : '';
        const descriptionExtended = this.props.instrumentGroupItem.description ? this.props.instrumentGroupItem.description.value : '';
        const linkUrl = _.get(this.props.instrumentGroupItem, 'alternate_link.url') || _.get(this.props.instrumentGroupItem, 'instrument.alias');
        const linkLabel = _.get(this.props.instrumentGroupItem, 'alternate_link.title') || _.get(this.props.instrumentGroupItem, 'instrument.field_gruhn_category_id.value');
        const className = this.props.className ? this.props.className : '';

        return (
            <div className={`mb-4 col-md-6 col-lg-6 col-xl-4 InstrumentGroupItem-container ${className}`}>
                <div className="Thumbnail">
                    <FailsafeImg
                        src={instrumentImageUrlRef(this.props.instrumentGroupItem.instrument, 'large')}
                        alt={instrumentImageAltRef(this.props.instrumentGroupItem.instrument)}
                        onClick={(e) => {
                            this.setState({
                                isLighboxOpen: true
                            });
                            this.imageClick();
                        }}
                    />
                    {
                        (this.state.item) ? this.renderLightbox(this.state.item.field_instr_image) : null
                    }
                </div>

                <div className="Info">
                    <h5
                        className="Title"
                        onClick={(e) => {
                            this.setState({
                                isLighboxOpen: true
                            });
                            this.imageClick();
                        }
                        }
                    >
                        <span>{manufacturer}</span>
                        <span> {model}</span>
                        <span> {year}</span>
                    </h5>

                    {descriptionExtended ? <p>{descriptionExtended}</p> : ''}
                    <p>{description}</p>
                    {this.props.showPrice ? (<div><span className="Price">{renderPrice(this.props.instrumentGroupItem.instrument)}</span></div>) : null}
                    <p className="Serial">Product:
                        <a href={linkUrl} className="InstrumentTitle">{linkLabel}</a>
                    </p>
                </div>
            </div>
        );
    }
}

export default InstrumentGroupItem;



// WEBPACK FOOTER //
// ./src/components/pages/default/InstrumentGroupItem.tsx